export default __webpack_public_path__ + "static/media/menu.b60dacd5.png";